import { z } from 'zod/v4';

import { ZOD_ERROR } from '../models/constants';
import { assetLicenseAssignmentsResultSchema } from './asset-license-assignments-result.schema';
import { BaseMessage, baseMessageSchema } from './base-message.schema';

const assetLicenseAssignmentsSchema = z.object({
  Id: z.string(),
  Type: z.string(),
  Result: assetLicenseAssignmentsResultSchema,
});

export const assetLicenseAssignmentsEventSchema = baseMessageSchema.transform(
  (data) => {
    const message = JSON.parse(data.message) as BaseMessage;
    const { success, data: result } = assetLicenseAssignmentsSchema
      .transform((d) => ({
        eventType: data.eventType,
        id: d.Id,
        type: d.Type,
        result: {
          errorCode: d.Result.ErrorCode,
          totalLicensesAssigned: d.Result.TotalLicensesAssigned,
          totalLicensesUnAssigned: d.Result.TotalLicensesUnAssigned,
          totalLicensesUpdated: d.Result.TotalLicensesUpdated,
          totalLicensesNotProcessed: d.Result.TotalLicensesNotProcessed,
        },
      }))
      .safeParse(message);

    if (success) {
      return result;
    }

    return {
      eventType: '',
      id: '',
      type: '',
      result: {
        errorCode: ZOD_ERROR,
        totalLicensesAssigned: 0,
        totalLicensesUnAssigned: 0,
        totalLicensesUpdated: 0,
        totalLicensesNotProcessed: [''],
      },
    };
  }
);
